import React, { useState, useRef } from 'react'
import { useEffect } from 'react'
import Swal from 'sweetalert2'

import {
    uidproject,
    comma,
    moneyDates,
    removeComma,
    loadImage,
    offerok,
    alertreturn,
    getTime,
} from '../../service/project'

import { modaltap } from '../../service/tabarray'
import { STEP, nextStep } from '../Project/projectStepManager'

import ProjectRightView from './projectViews/ProjectRightView'

function Projectpgs({
    pg,
    path,
    setPgs,
    setupPgs,
    admin,
    my,
    fine,
    contract,
    userinfo,
    setContract,
    setProjectData,
    setNum,
    bigLabels,
    setBigl,
    exdata,
    offerlist,
    setprojecthistory,
    stampid,
    setStampid,
    fresh,
    upgrade,
    goEstimateWriteAndOpenEditor,
    rightViewNum,
    setRightViewNum,
}) {
    const [nums, setNums] = useState(0)
    const [contractPage, setContractPage] = useState(0)
    const [imageSrc, setImageSrc] = useState(1)
    const [currentStep, setCurrentStep] = useState(STEP.TEMP)

    const safeContract = contract || {}
    const userId = userinfo && userinfo.uid
    const shownNotReadyRef = useRef({})

    useEffect(
        function () {
            if (typeof rightViewNum === 'number') {
                setNums(rightViewNum)
            }
        },
        [rightViewNum],
    )
    useEffect(
        function () {
            var step = getManagedStep()
            var autoNum = getAutoTabNumByStep(step)

            setNums(autoNum)

            if (typeof setRightViewNum === 'function') {
                setRightViewNum(autoNum)
            }
        },
        [currentStep, pg && pg.adminstatus],
    )

    function getManagedStep() {
        if (currentStep) return currentStep
        if (pg && pg.adminstatus) return pg.adminstatus
        return STEP.TEMP
    }

    function getStepOrder(step) {
        var orderMap = {}

        orderMap[STEP.TEMP] = 0
        orderMap[STEP.REGISTER] = 1
        orderMap[STEP.ESTIMATE_WRITE] = 2
        orderMap[STEP.ESTIMATE_RECEIVE] = 3
        orderMap[STEP.ESTIMATE_APPROVE] = 4

        orderMap[STEP.CONTRACT_WRITE] = 5
        orderMap[STEP.CONTRACT_RECEIVE] = 6
        orderMap[STEP.CONTRACT_SIGN] = 7

        orderMap[STEP.DEPOSIT] = 8
        orderMap[STEP.DEV1] = 9
        orderMap[STEP.DEV1_RECEIVE] = 10
        orderMap[STEP.DEV1_APPROVE] = 11
        orderMap[STEP.MIDDLE] = 12

        orderMap[STEP.DEV2] = 13
        orderMap[STEP.DEV2_RECEIVE] = 14
        orderMap[STEP.DEV2_APPROVE] = 15

        orderMap[STEP.FINAL_REPORT] = 16
        orderMap[STEP.FINAL_REPORT_RECEIVE] = 17
        orderMap[STEP.FINAL_REPORT_APPROVE] = 18
        orderMap[STEP.FINAL_PAY] = 19
        orderMap[STEP.DONE] = 20

        if (typeof orderMap[step] === 'number') {
            return orderMap[step]
        }

        return -1
    }

    function getAutoTabNumByStep(step) {
        if (step === STEP.TEMP) return 0
        if (step === STEP.REGISTER) return 0

        if (step === STEP.ESTIMATE_WRITE) return 0
        if (step === STEP.ESTIMATE_RECEIVE) return 1
        if (step === STEP.ESTIMATE_APPROVE) return 1

        if (step === STEP.CONTRACT_WRITE) return 1
        if (step === STEP.CONTRACT_RECEIVE) return 3
        if (step === STEP.CONTRACT_SIGN) return 3

        if (step === STEP.DEPOSIT) return my ? 5 : 41

        if (step === STEP.DEV1) return my ? 5 : 5
        if (step === STEP.DEV1_RECEIVE) return 5
        if (step === STEP.DEV1_APPROVE) return 5

        if (step === STEP.MIDDLE) return my ? 6 : 42

        if (step === STEP.DEV2) return 6
        if (step === STEP.DEV2_RECEIVE) return 6
        if (step === STEP.DEV2_APPROVE) return 6

        if (step === STEP.FINAL_REPORT) return 7
        if (step === STEP.FINAL_REPORT_RECEIVE) return 7
        if (step === STEP.FINAL_REPORT_APPROVE) return 7

        if (step === STEP.FINAL_PAY) return my ? 7 : 43

        if (step === STEP.DONE) return 8

        return 0
    }

    function getMinStepByNums(tabNum) {
        if (tabNum === 1) return STEP.ESTIMATE_RECEIVE
        if (tabNum === 2) return STEP.CONTRACT_RECEIVE
        if (tabNum === 3) return STEP.CONTRACT_RECEIVE

        if (tabNum === 4) return STEP.DEPOSIT
        if (tabNum === 41) return STEP.DEPOSIT
        if (tabNum === 42) return STEP.MIDDLE
        if (tabNum === 43) return STEP.FINAL_PAY

        if (tabNum === 5) return my ? STEP.DEPOSIT : STEP.DEV1_RECEIVE
        if (tabNum === 6) return my ? STEP.MIDDLE : STEP.DEV2_RECEIVE
        if (tabNum === 7) return my ? STEP.FINAL_REPORT : STEP.FINAL_REPORT_RECEIVE

        if (tabNum === 8) return STEP.DONE
        return STEP.TEMP
    }

    function getMaxTabNumByStep(step) {
        if (step === STEP.TEMP) return 0
        if (step === STEP.REGISTER) return 0

        if (step === STEP.ESTIMATE_WRITE) return 0
        if (step === STEP.ESTIMATE_RECEIVE) return 1
        if (step === STEP.ESTIMATE_APPROVE) return 1

        if (step === STEP.CONTRACT_WRITE) return 1
        if (step === STEP.CONTRACT_RECEIVE) return 3
        if (step === STEP.CONTRACT_SIGN) return 3

        if (step === STEP.DEPOSIT) return my ? 5 : 41

        if (step === STEP.DEV1) return 5
        if (step === STEP.DEV1_RECEIVE) return 5
        if (step === STEP.DEV1_APPROVE) return 5

        if (step === STEP.MIDDLE) return my ? 6 : 42

        if (step === STEP.DEV2) return 6
        if (step === STEP.DEV2_RECEIVE) return 6
        if (step === STEP.DEV2_APPROVE) return 6

        if (step === STEP.FINAL_REPORT) return 7
        if (step === STEP.FINAL_REPORT_RECEIVE) return 7
        if (step === STEP.FINAL_REPORT_APPROVE) return 7

        if (step === STEP.FINAL_PAY) return my ? 7 : 43

        if (step === STEP.DONE) return 8

        return 0
    }

    function getRepresentativeTabByRightViewNum(viewNum) {
        if (viewNum === 0) return ['프로젝트등록', 1]
        if (viewNum === 1) return ['견적진행', 2]
        if (viewNum === 3) return ['계약진행', 3]

        if (viewNum === 5) return ['프로젝트 진행', 4]
        if (viewNum === 6) return ['프로젝트 진행', 4]
        if (viewNum === 7) return ['프로젝트 진행', 4]

        if (viewNum === 8) return ['프로젝트 완료', 5]

        return null
    }

    function canViewRealByNums(tabNum) {
        var minStep = getMinStepByNums(tabNum)
        var managedStep = getManagedStep()

        if (tabNum === 4) {
            return getStepOrder(managedStep) >= getStepOrder(STEP.DEPOSIT)
        }

        return getStepOrder(managedStep) >= getStepOrder(minStep)
    }

    function getExampleLabelByNums(tabNum) {
        if (tabNum === 1) return '견적서'
        if (tabNum === 2) return '사양서'
        if (tabNum === 3) return '계약서'
        if (tabNum === 4) return '납부'
        if (tabNum === 5) return '1단계 개발 보고서'
        if (tabNum === 6) return '2단계 개발 보고서'
        if (tabNum === 7) return '3단계 개발 보고서'
        if (tabNum === 8) return '프로젝트 완료'
        return '문서'
    }

    function getViewContractForTab(tabNum) {
        if (!canViewRealByNums(tabNum)) {
            return exdata
        }
        return contract ? contract : exdata
    }

    function applyNextManagedStep(baseStep, extraPgData) {
        var sourceStep = baseStep || getManagedStep()
        var next = nextStep(sourceStep)

        setCurrentStep(next)

        setPgs(function (prevPg) {
            return {
                ...prevPg,
                ...(extraPgData || {}),
                adminstatus: next,
            }
        })
    }

    useEffect(
        function () {
            if (pg && pg.adminstatus) {
                setCurrentStep(pg.adminstatus)
            }
        },
        [pg],
    )

    useEffect(function () {
        if (path && bigLabels && !admin) {
            uidproject(path).then(function (response) {
                var saveListWithConvertedMinicate = response.data.map(function (item) {
                    if (item.minicate) {
                        item.minicate = JSON.parse(item.minicate)
                        item.conditions = JSON.parse(item.conditions)
                    }
                    return item
                })

                if (path && !admin && !fine) {
                    var pgValue = saveListWithConvertedMinicate[0]

                    setPgs(pgValue)

                    var adminstatus = saveListWithConvertedMinicate[0].adminstatus

                    if (adminstatus) {
                        setCurrentStep(adminstatus)
                    }

                    function findLabelKeyByAdminstatus(adminstatus) {
                        var key = null
                        var item = null
                        var array = null

                        for (key in bigLabels) {
                            if (bigLabels.hasOwnProperty(key)) {
                                array = bigLabels[key]
                                for (var i = 0; i < array.length; i++) {
                                    item = array[i]
                                    if (item.label === adminstatus) {
                                        return key
                                    }
                                }
                            }
                        }
                        return null
                    }

                    var foundKey = findLabelKeyByAdminstatus(adminstatus)
                    setBigl(foundKey)
                    setNum([
                        foundKey,
                        foundKey === '전체'
                            ? 0
                            : foundKey === '프로젝트등록'
                            ? 1
                            : foundKey === '견적진행'
                            ? 2
                            : foundKey === '계약진행'
                            ? 3
                            : foundKey === '프로젝트 진행'
                            ? 4
                            : 5,
                    ])
                    setupPgs(saveListWithConvertedMinicate[0])
                } else {
                    setProjectData(saveListWithConvertedMinicate[0])
                }
            })
        }
    }, [])

    useEffect(
        function () {
            var canViewCurrentTab = canViewRealByNums(nums)

            function alertOnce(key, label) {
                if (shownNotReadyRef.current[key]) return
                shownNotReadyRef.current[key] = true
                alertreturn('notready', label)
            }
            if (nums === 8) {
                if (contract && contract.develop3) {
                    loadImage(contract, setImageSrc, 'develop3')
                }
                return
            }

            if (nums !== 3 && nums !== 4 && nums !== 0) {
                if (!canViewCurrentTab) {
                    alertOnce('tab-' + nums, getExampleLabelByNums(nums))
                    loadImage(
                        exdata,
                        setImageSrc,
                        nums === 1
                            ? 'estimate'
                            : nums === 2
                            ? 'specification'
                            : nums === 5
                            ? 'develop1'
                            : nums === 6
                            ? 'develop2'
                            : 'develop3',
                    )
                    return
                }

                if (nums === 1 && contract && contract.estimate) {
                    loadImage(contract, setImageSrc, 'estimate')
                } else if (nums === 2 && contract && contract.specification) {
                    loadImage(contract, setImageSrc, 'specification')
                } else if (nums === 5 && contract && contract.develop1) {
                    loadImage(contract, setImageSrc, 'develop1')
                } else if (nums === 6 && contract && contract.develop2) {
                    loadImage(contract, setImageSrc, 'develop2')
                } else if (nums === 7 && contract && contract.develop3) {
                    loadImage(contract, setImageSrc, 'develop3')
                } else {
                    if (nums !== 1) {
                        alertOnce('empty-' + nums, getExampleLabelByNums(nums))
                    }

                    loadImage(
                        exdata,
                        setImageSrc,
                        nums === 1
                            ? 'estimate'
                            : nums === 2
                            ? 'specification'
                            : nums === 5
                            ? 'develop1'
                            : nums === 6
                            ? 'develop2'
                            : 'develop3',
                    )
                }
            } else if (nums === 3) {
                if (!canViewCurrentTab) {
                    alertOnce('contract-tab', '계약서')
                    loadImage(exdata, setImageSrc, 'specification')
                    return
                } else if (!contract || contract.uid === 'exampledata') {
                    alertOnce('contract-sign', '계약서')
                    loadImage(exdata, setImageSrc, 'specification')
                    return
                }

                if (contract && contract.specification) {
                    loadImage(contract, setImageSrc, 'specification')
                } else {
                    loadImage(exdata, setImageSrc, 'specification')
                }
            } else if (nums === 4) {
                if (!canViewCurrentTab) {
                    alertOnce('payment-tab', '납부')
                    return
                }
            }
        },
        [nums, currentStep, contract, exdata],
    )

    const moneyDate = function (num, tab) {
        const isDeposit = num === 1
        const isMiddle = num === 2

        const defaultDate = isDeposit ? contract.d1f || '' : isMiddle ? contract.d3f || '' : contract.d6f || ''
        const defaultMoney = isDeposit
            ? contract.beforemoney || ''
            : isMiddle
            ? contract.middlemoney || ''
            : contract.aftermoney || ''

        Swal.fire({
            title: '입금 날짜를 입력해주세요',
            html:
                '<input type="date" id="swal-input1" class="projectAdd_inputbox" value="' +
                defaultDate +
                '">' +
                '<input placeholder="금액을 입력해주세요" type="number" id="swal-input2" class="projectAdd_inputbox mt10" value="' +
                String(defaultMoney).replace(/,/g, '') +
                '">',
            inputAttributes: {
                autocapitalize: 'off',
            },
            showCancelButton: true,
            confirmButtonText: defaultDate || defaultMoney ? '수정' : '입력',
            showLoaderOnConfirm: true,
            cancelButtonText: '아니요',
            preConfirm: function () {
                var dateValue = document.getElementById('swal-input1').value
                var moneyValue = document.getElementById('swal-input2').value

                if (!dateValue) {
                    Swal.showValidationMessage('입금 날짜를 입력해주세요')
                    return false
                }

                if (!moneyValue) {
                    Swal.showValidationMessage('입금 금액을 입력해주세요')
                    return false
                }

                return [dateValue, moneyValue]
            },
            allowOutsideClick: function () {
                return !Swal.isLoading()
            },
        }).then(function (result) {
            if (result.isConfirmed) {
                var inputDate = result.value

                moneyDates(contract.uid, tab, inputDate[0], inputDate[1])
                    .then(function () {
                        Swal.fire({
                            title: '입금정보가 수정되었습니다',
                        })

                        if (num === 1) {
                            setContract(function (prevPg) {
                                return {
                                    ...prevPg,
                                    beforemoney: inputDate[1],
                                    d1f: inputDate[0],
                                }
                            })
                        } else if (num === 2) {
                            setContract(function (prevPg) {
                                return {
                                    ...prevPg,
                                    middlemoney: inputDate[1],
                                    d3f: inputDate[0],
                                }
                            })
                        } else if (num === 3) {
                            setContract(function (prevPg) {
                                return {
                                    ...prevPg,
                                    aftermoney: inputDate[1],
                                    d6f: inputDate[0],
                                }
                            })
                        }
                    })
                    .catch(function (error) {
                        console.error('Error:', error)
                        Swal.fire('입금 날짜를 업데이트하는 동안 오류가 발생했습니다.')
                    })
            }
        })
    }

    const confirmPayment = function (stepName) {
        const now = getTime()

        if (!contract || !contract.uid) {
            Swal.fire('계약 정보가 없습니다.')
            return
        }

        let confirmField = ''
        let inputDate = ''
        let inputMoney = ''

        if (stepName === STEP.DEPOSIT) {
            confirmField = 'd2f'
            inputDate = safeContract.d1f || ''
            inputMoney = safeContract.beforemoney || ''
        } else if (stepName === STEP.MIDDLE) {
            confirmField = 'd4f'
            inputDate = safeContract.d3f || ''
            inputMoney = safeContract.middlemoney || ''
        } else if (stepName === STEP.FINAL_PAY) {
            confirmField = 'e1'
            inputDate = safeContract.d6f || ''
            inputMoney = safeContract.aftermoney || ''
        }

        if (!inputDate || !inputMoney) {
            Swal.fire('먼저 입금 정보가 입력되어야 합니다.')
            return
        }

        Swal.fire({
            title: '입금 확인 처리하시겠습니까?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: '확인',
            cancelButtonText: '취소',
        }).then(function (result) {
            if (!result.isConfirmed) return

            moneyDates(contract.uid, confirmField, now, inputMoney)
                .then(function () {
                    setContract(function (prev) {
                        return {
                            ...prev,
                            [confirmField]: now,
                        }
                    })

                    Swal.fire('입금 확인 처리되었습니다.').then(function () {
                        window.location.reload()
                    })
                })
                .catch(function (error) {
                    console.error('Error:', error)
                    Swal.fire('입금 확인 처리 중 오류가 발생했습니다.')
                })
        })
    }

    const buttonRender = function (label, value) {
        const money =
            label === '선금'
                ? safeContract.beforemoney
                : label === '중도금'
                ? safeContract.middlemoney
                : safeContract.aftermoney

        const dates = label === '선금' ? safeContract.d1f : label === '중도금' ? safeContract.d3f : safeContract.d6f

        const managedStep = getManagedStep()
        const stepName = label === '선금' ? STEP.DEPOSIT : label === '중도금' ? STEP.MIDDLE : STEP.FINAL_PAY
        const isCurrentPayStep = managedStep === stepName
        const isPassedPayStep = getStepOrder(managedStep) > getStepOrder(stepName)

        const confirmedAt =
            label === '선금' ? safeContract.d2f : label === '중도금' ? safeContract.d4f : safeContract.e1

        const canInputMiddle = !!safeContract.r1f && getStepOrder(managedStep) >= getStepOrder(STEP.MIDDLE)
        const canInputFinal = !!safeContract.r3f && getStepOrder(managedStep) >= getStepOrder(STEP.FINAL_PAY)

        if (!admin) {
            if (label === '중도금' && !money && !dates && !canInputMiddle) {
                return <span className="subtext">1단계 개발 보고서 승인 후 입력 가능</span>
            }

            if (label === '잔금' && !money && !dates && !canInputFinal) {
                return <span className="subtext">2, 3단계 개발 보고서 승인 후 입력 가능</span>
            }

            if (money || dates) {
                return (
                    <>
                        <div className="mr10">
                            <div style={{ color: confirmedAt ? 'red' : 'red' }}>
                                {confirmedAt ? label + ' 입금 확인 완료' : label + ' 입력 완료'}
                            </div>
                            {dates ? <div className="f12">입금날짜 : {dates}</div> : null}
                            {money ? <div className="f12">입금액 : {comma(money)}원</div> : null}
                            {confirmedAt ? <div className="f12">확인일시 : {confirmedAt}</div> : null}
                        </div>

                        {!confirmedAt ? (
                            <button
                                className="navibtn_hover ps ml10"
                                onClick={function () {
                                    moneyDate(value, stepName)
                                }}
                            >
                                수정
                            </button>
                        ) : null}
                    </>
                )
            }

            if (label === '선금') {
                return (
                    <>
                        <span>{label} 납부중</span>
                        <button
                            className="navibtn_hover ps ml10"
                            onClick={function () {
                                moneyDate(value, stepName)
                            }}
                        >
                            입력
                        </button>
                    </>
                )
            }

            if (label === '중도금' && canInputMiddle) {
                return (
                    <>
                        <span>{label} 납부중</span>
                        <button
                            className="navibtn_hover ps ml10"
                            onClick={function () {
                                moneyDate(value, stepName)
                            }}
                        >
                            입력
                        </button>
                    </>
                )
            }

            if (label === '잔금' && canInputFinal) {
                return (
                    <>
                        <span>{label} 납부중</span>
                        <button
                            className="navibtn_hover ps ml10"
                            onClick={function () {
                                moneyDate(value, stepName)
                            }}
                        >
                            입력
                        </button>
                    </>
                )
            }

            return <span>대기중</span>
        }

        if (!(money || dates)) {
            if (label === '선금' && managedStep === STEP.DEPOSIT) {
                return <span>선금 입금 대기중</span>
            }

            if (label === '중도금') {
                if (!canInputMiddle) {
                    return <span className="subtext">1단계 개발 보고서 승인 후 입력 가능</span>
                }

                if (managedStep === STEP.MIDDLE) {
                    return <span>중도금 입금 대기중</span>
                }
            }

            if (label === '잔금') {
                if (!canInputFinal) {
                    return <span className="subtext">2, 3단계 개발 보고서 승인 후 입력 가능</span>
                }

                if (managedStep === STEP.FINAL_PAY) {
                    return <span>잔금 입금 대기중</span>
                }
            }

            return <span className="subtext">계약서 전자서명 후 입력 가능</span>
        }

        if (isCurrentPayStep) {
            if (confirmedAt) {
                return (
                    <div className="mr10">
                        <div style={{ color: 'red' }}>{label} 입금 확인 완료</div>
                        {dates ? <div className="f12">입금날짜 : {dates}</div> : null}
                        {money ? <div className="f12">입금액 : {comma(money)}원</div> : null}
                        <div className="f12">확인일시 : {confirmedAt}</div>
                    </div>
                )
            }

            return (
                <>
                    <div className="mr10">
                        <div style={{ color: 'red' }}>{label} 입력 확인 필요</div>
                        {dates ? <div className="f12">입금날짜 : {dates}</div> : null}
                        {money ? <div className="f12">입금액 : {comma(money)}원</div> : null}
                    </div>

                    <button
                        className="navibtn_hover ps ml10"
                        onClick={function () {
                            confirmPayment(stepName)
                        }}
                    >
                        입금 확인
                    </button>
                </>
            )
        }

        if (isPassedPayStep) {
            return (
                <div className="mr10">
                    <div style={{ color: confirmedAt ? 'red' : 'inherit' }}>
                        {confirmedAt ? label + ' 입금 확인 완료' : label + ' 입력완료'}
                    </div>
                    {dates ? <div className="f12">입금날짜 : {dates}</div> : null}
                    {money ? <div className="f12">입금액 : {comma(money)}원</div> : null}
                    {confirmedAt ? <div className="f12">확인일시 : {confirmedAt}</div> : null}
                </div>
            )
        }

        return (
            <div className="mr10">
                <div style={{ color: confirmedAt ? 'red' : 'inherit' }}>
                    {confirmedAt ? label + ' 입금 확인 완료' : label + ' 입력완료'}
                </div>
                {dates ? <div className="f12">입금날짜 : {dates}</div> : null}
                {money ? <div className="f12">입금액 : {comma(money)}원</div> : null}
            </div>
        )
    }

    const offerOks = function (num) {
        let fieldToUpdate = num === 1 ? 'b3f' : num === 5 ? 'r1f' : num === 6 ? 'r2f' : num === 7 ? 'r3f' : ''

        const uploadPath = num == 1 ? 'estimate' : num == 5 ? 'develop1' : num == 6 ? 'develop2' : 'develop3'
        const managedStep = getManagedStep()

        Swal.fire({
            title: '승인 하시겠습니까?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: '아니요',
            confirmButtonText: '네',
        }).then(function (result) {
            if (result.isConfirmed) {
                const lengthPoint = offerlist.length
                const now = getTime()

                offerok(contract.uid, now, uploadPath, managedStep, lengthPoint, userId).then(function (response) {
                    if (response.data) {
                        if (num === 1 && offerlist.length === 1) {
                            setContract(function (prevData) {
                                return {
                                    ...prevData,
                                    b2f: now,
                                    b3: now,
                                    b3f: now,
                                }
                            })

                            if (setprojecthistory) {
                                setprojecthistory(function (prevData) {
                                    return {
                                        ...prevData,
                                        b2f: now,
                                        b3: now,
                                        b3f: now,
                                    }
                                })
                            }

                            applyNextManagedStep(managedStep, {
                                b2f: now,
                                b3: now,
                                b3f: now,
                            })
                        } else {
                            setContract(function (prevData) {
                                return {
                                    ...prevData,
                                    [fieldToUpdate]: now,
                                }
                            })

                            if (setprojecthistory) {
                                setprojecthistory(function (prevData) {
                                    return {
                                        ...prevData,
                                        [fieldToUpdate]: now,
                                    }
                                })
                            }

                            applyNextManagedStep(managedStep, {
                                [fieldToUpdate]: now,
                            })
                        }

                        Swal.fire({
                            title: '승인되었습니다',
                            icon: 'success',
                        }).then(function () {
                            window.location.reload()
                        })
                    }
                })
            }
        })
    }

    const countNum = function (value) {
        if (value === 1) {
            setContractPage(function (prev) {
                if (prev === 5) {
                    Swal.fire({
                        title: '마지막페이지 입니다',
                        icon: 'warning',
                    })
                    return prev
                }

                return prev + 1
            })
        } else {
            setContractPage(function (prev) {
                if (prev === 0) {
                    Swal.fire({
                        title: '처음페이지 입니다',
                        icon: 'warning',
                    })
                    return prev
                }

                return prev - 1
            })
        }
    }

    const lastOffer = offerlist && offerlist[offerlist.length - 1] ? offerlist[offerlist.length - 1] : null
    const displayStep = getManagedStep()
    const maxTabNum = getMaxTabNumByStep(displayStep)
    const autoTabNum = getAutoTabNumByStep(displayStep)
    const canViewCurrentNums = canViewRealByNums(nums)
    const viewContract = getViewContractForTab(nums)

    const visibleModaltap = my
        ? modaltap.filter(function (tab) {
              return tab.label !== '사양서' && tab.label !== '납부'
          })
        : modaltap

    const showExampleOverlay =
        nums !== 0 &&
        ((!canViewCurrentNums && nums >= 1 && nums <= 7) ||
            !contract ||
            (nums === 1 && canViewCurrentNums && !safeContract.estimate) ||
            (nums === 2 && canViewCurrentNums && !safeContract.specification) ||
            (nums === 3 && canViewCurrentNums && (!contract || contract.uid === 'exampledata')) ||
            (nums === 4 && !canViewCurrentNums) ||
            (nums === 5 && canViewCurrentNums && !safeContract.develop1) ||
            (nums === 6 && canViewCurrentNums && !safeContract.develop2) ||
            (nums === 7 && canViewCurrentNums && !safeContract.develop3))

    return (
        <>
            {pg ? (
                <div className={fine ? 'add_right_wrap full' : ' wide pgdetail ModalMypageInfo-1 mt0 rd10 '}>
                    {my ? (
                        <nav>
                            <ul className="w100 flex">
                                {visibleModaltap.map(function (item) {
                                    var isDisabled = item.value > maxTabNum
                                    var isSelected = item.value === nums

                                    return (
                                        <li
                                            key={item.value}
                                            className={isSelected ? 'selected p10-1' : 'p10-1'}
                                            style={{
                                                opacity: isDisabled ? 0.4 : 1,
                                                cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                pointerEvents: isDisabled ? 'none' : 'auto',
                                            }}
                                            onClick={function () {
                                                if (isDisabled) return

                                                shownNotReadyRef.current = {}
                                                setNums(item.value)

                                                if (typeof setRightViewNum === 'function') {
                                                    setRightViewNum(item.value)
                                                }

                                                var nextTab = getRepresentativeTabByRightViewNum(item.value)

                                                if (nextTab) {
                                                    if (typeof setBigl === 'function') {
                                                        setBigl(nextTab[0])
                                                    }

                                                    if (typeof setNum === 'function') {
                                                        setNum(nextTab)
                                                    }
                                                }
                                            }}
                                        >
                                            {item.label}
                                        </li>
                                    )
                                })}
                            </ul>
                        </nav>
                    ) : (
                        ''
                    )}

                    <ProjectRightView
                        nums={nums}
                        my={my}
                        pg={pg}
                        fine={fine}
                        admin={admin}
                        displayStep={displayStep}
                        lastOffer={lastOffer}
                        userinfo={userinfo}
                        contract={contract}
                        safeContract={safeContract}
                        exdata={exdata}
                        viewContract={viewContract}
                        canViewCurrentNums={canViewCurrentNums}
                        showExampleOverlay={showExampleOverlay}
                        imageSrc={imageSrc}
                        offerOks={offerOks}
                        offerlist={offerlist}
                        countNum={countNum}
                        contractPage={contractPage}
                        setStampid={setStampid}
                        stampid={stampid}
                        setContract={setContract}
                        fresh={fresh}
                        buttonRender={buttonRender}
                    />
                </div>
            ) : (
                ''
            )}
        </>
    )
}

export default Projectpgs
